import _ from 'lodash';
import { schemaShouldShowConfigTypes, schemaTypes } from './config';
import { currencyLabel } from 'v2/common/constants';

const isAdmin = window?.isAdmin;

const caseBasedOutputSchema = [
  {
    name: 'numberOfMinutesFromEntry',
    label: 'Number Of Minutes From Entry',
    type: schemaTypes.minute,
    category: 'exitSignalLeftOperand',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
    ],
  },
  {
    name: 'stopLoss',
    label: 'Current Transaction Loss %',
    type: schemaTypes.number,
    category: 'strategyStop',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  {
    name: 'stopGain',
    label: 'Current Transaction Profit %',
    type: schemaTypes.number,
    category: 'strategyStop',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  {
    name: 'stopLossAmount',
    label: `Current Transaction Loss ${currencyLabel}`,
    type: schemaTypes.number,
    category: 'strategyStop',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  {
    name: 'stopGainAmount',
    label: `Current Transaction Profit ${currencyLabel}`,
    type: schemaTypes.number,
    category: 'strategyStop',
    shouldShowConfigs: [
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand
    ],
  },
  {
    name: 'transactionLossPercent',
    label: 'Transaction Loss %',
    type: schemaTypes.number,
    category: 'strategyStop',
    isDisplay: isAdmin,
    caseIndex: undefined,
    shouldShowConfigs: [],
    multipleCaseShouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.entryRightOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.exitRightOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand,
    ],
  },
  {
    name: 'transactionGainPercent',
    label: 'Transaction Profit %',
    type: schemaTypes.number,
    category: 'strategyStop',
    isDisplay: isAdmin,
    caseIndex: undefined,
    shouldShowConfigs: [],
    multipleCaseShouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.entryRightOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.exitRightOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand,
    ],
  },
  {
    name: 'transactionLossAmount',
    label: 'Transaction Loss Amount',
    type: schemaTypes.number,
    category: 'strategyStop',
    isDisplay: isAdmin,
    caseIndex: undefined,
    shouldShowConfigs: [],
    multipleCaseShouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.entryRightOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.exitRightOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand,
    ],
  },
  {
    name: 'transactionGainAmount',
    label: 'Transaction Profit Amount',
    type: schemaTypes.number,
    category: 'strategyStop',
    isDisplay: isAdmin,
    caseIndex: undefined,
    shouldShowConfigs: [],
    multipleCaseShouldShowConfigs: [
      schemaShouldShowConfigTypes.entryLeftOperand,
      schemaShouldShowConfigTypes.entryRightOperand,
      schemaShouldShowConfigTypes.exitLeftOperand,
      schemaShouldShowConfigTypes.exitRightOperand,
      schemaShouldShowConfigTypes.adjustmentLeftOperand,
      schemaShouldShowConfigTypes.adjustmentRightOperand,
    ],
  }
];

export const getConfigs = (caseIndex) => {
  return _.chain(caseBasedOutputSchema)
    .pickBy(({ isDisplay }) => isDisplay !== false)
    .map(({
      label, name, type, shouldShowConfigs, category, multipleCaseShouldShowConfigs, ...rest
    }) => {
      const resolvedCaseIndex = _.has(rest, 'caseIndex') ? rest?.caseIndex : caseIndex;

      return {
        type,
        schemaName: name,
        category,
        shouldShowConfigs,
        multipleCaseShouldShowConfigs,
        name: `case.${caseIndex}.${name}`,
        label,
        tagConfig: { tag: `Case ${caseIndex + 1}`, color: '#7987a1' },
        caseIndex: resolvedCaseIndex,
        priority: 80,
      };
    })
    .value();
};


export const buildCaseBasedOutputSchema = (cases) => {
  if (_.isEmpty(cases)) return null;

  return _.chain(cases)
    .map((caseConfig, caseIndex) => {
      return getConfigs(caseIndex);
    })
    .compact()
    .flattenDeep()
    .value();
};
